__turbopack_context__.v({
  "head": "styles-module__k_4Muq__head",
  "heading": "styles-module__k_4Muq__heading",
  "num": "styles-module__k_4Muq__num",
  "root": "styles-module__k_4Muq__root",
  "step": "styles-module__k_4Muq__step",
  "stepBody": "styles-module__k_4Muq__stepBody",
  "stepFirst": "styles-module__k_4Muq__stepFirst",
  "stepTitle": "styles-module__k_4Muq__stepTitle",
  "sub": "styles-module__k_4Muq__sub",
  "tag": "styles-module__k_4Muq__tag",
  "track": "styles-module__k_4Muq__track",
  "trackTitle": "styles-module__k_4Muq__trackTitle",
  "tracks": "styles-module__k_4Muq__tracks",
});
